module.exports = __webpack_public_path__ + "static/media/eric_zhou.92703c6a.png";